import { GetAuth } from '@/features/Auth/auth';
import { useNavigate } from 'react-router-dom';
import React, { useState, useEffect, useContext } from 'react';


export const Landing = (prop: any) => {
    const navigate = useNavigate();
    const [isAuth, setIsAuth] = useState(false)

    const handleErrorAuth = (e:boolean) => {
        setIsAuth(e)
    }

    const auth = GetAuth()
    auth.then(function (result: any) {
        setIsAuth(result)

    }).catch(handleErrorAuth)

    useEffect(() => {
        if (isAuth) {
            navigate("/admin/document-monitoring")
        }
    }, [isAuth])


    return (
        <React.Fragment>
            <section id="about2">
                <div className="container small">
                    <div className="fn_cs_shortabout">
                        <div className="about_left">
                            <h3 className="fn__maintitle" data-text="Document Identity Validation">Document Identity Validation</h3>
                            <div className="fn_cs_divider">
                                <div className="divider">
                                    <span></span>
                                    <span></span>
                                </div>
                            </div>
                            <div className="desc">
                            
                            </div>
                            <a href={process.env.REACT_APP_LOGIN} className="metaportal_fn_button"><span>Login with SSO</span></a>
                        </div>
                        {/* <div className="about_right">
                            
                        </div> */}
                    </div>

                </div>

            </section>

        </React.Fragment>
    )
}